<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    titleFontFace: {
      type: String,
      default: 'inherit'
    },
    content: {
      type: String,
      default: ''
    },
    footer: {
      type: String,
      default: ''
    }
  },
  computed: {
    titleStyle() {
      return {
        'font-family': this.titleFontFace
      }
    }
  }
}
</script>
<template>
  <div class="infobox-wrapper">
      <f7-card style="'border-radius': '7px'">
        <f7-card-header v-if="title != ''" :style="titleStyle" v-html="title" :class="{'card-header-no-border': content == ''}">
        </f7-card-header>
        <f7-card-content :inner="false"  v-if="content != ''">
          <div class="card-content-inner ql-editor" v-html="content"> </div>
        </f7-card-content>
        <f7-card-footer v-if="footer != ''" :style="footerStyle" v-html="footer">
        </f7-card-footer>
      </f7-card>
  </div>
</template>
<style scoped>
  /* .card-content:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: auto;
    right: auto;
    height: 1px;
    width: 100%;
    background-color: rgba(220, 220, 220, 0.25);
    display: block;
    z-index: 15;
    -webkit-transform-origin: 50% 0;
    transform-origin: 50% 0;
  } */
  .card-header-no-border {
    border-bottom: none!important;
  }
  .card-footer:before {
    background-color: rgba(220, 220, 220, 0.25)!important;
  }
  .card-header:after {
    background-color: rgba(220, 220, 220, 0)!important;
  }
  .infobox-wrapper{
    padding: 5px 5px!important;
  }
  .card {
    border-radius: 10px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/InfoBox.vue